import { StyleSheet } from 'aphrodite';
import { SPACE } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[40],
		padding: `${SPACE[16]}px ${SPACE[20]}px`,
	},
});
